import * as React from 'react';
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import { Typography } from '@mui/material';

export default function OppositeContentTimeline() {
  return (
    <Timeline position="alternate">
      <TimelineItem>
        <TimelineOppositeContent color="text.secondary" className="timelineYear">
          2022
        </TimelineOppositeContent>
        <TimelineSeparator className="timelineSeparator">
          <TimelineDot className="timelineDot" />
          <TimelineConnector className="" />
        </TimelineSeparator>
        <TimelineContent>
          <Typography variant="body2" className="timeLineText">
            Date
          </Typography>
          <Typography variant="body2" className="timeLineHeading" mb={0.5}>
            <strong>11/10/2022</strong>
          </Typography>
          <Typography variant="body2" className="timeLineText">
            User
          </Typography>
          <Typography variant="body2" className="timeLineHeading" mb={0.5}>
            <strong>Ajay</strong>
          </Typography>
          <Typography variant="body2" className="timeLineText">
            Task
          </Typography>
          <Typography variant="body2" className="timeLineHeading" mb={0.5}>
            <strong>Task1</strong>
          </Typography>
          <Typography variant="body2" className="timeLineText">
            Assign to
          </Typography>
          <Typography variant="body2" className="timeLineHeading" mb={0.5}>
            <strong>Vijay</strong>
          </Typography>
          <Typography variant="body2" className="timeLineText">
            Message
          </Typography>
          <Typography variant="body2" className="timeLineHeading" mb={0.5}>
            <strong>Lorem</strong>
          </Typography>
        </TimelineContent>
      </TimelineItem>
      <TimelineItem>
        <TimelineOppositeContent color="text.secondary" className="timelineYear">
          2021
        </TimelineOppositeContent>
        <TimelineSeparator className="timelineSeparator">
          <TimelineDot className="timelineDot" />
          <TimelineConnector className="" />
        </TimelineSeparator>
        <TimelineContent>
          <Typography variant="body2" className="timeLineText">
            Date
          </Typography>
          <Typography variant="body2" className="timeLineHeading" mb={0.5}>
            <strong>11/10/2022</strong>
          </Typography>
          <Typography variant="body2" className="timeLineText">
            User
          </Typography>
          <Typography variant="body2" className="timeLineHeading" mb={0.5}>
            <strong>Ajay</strong>
          </Typography>
          <Typography variant="body2" className="timeLineText">
            Task
          </Typography>
          <Typography variant="body2" className="timeLineHeading" mb={0.5}>
            <strong>Task1</strong>
          </Typography>
          <Typography variant="body2" className="timeLineText">
            Assign to
          </Typography>
          <Typography variant="body2" className="timeLineHeading" mb={0.5}>
            <strong>Vijay</strong>
          </Typography>
          <Typography variant="body2" className="timeLineText">
            Message
          </Typography>
          <Typography variant="body2" className="timeLineHeading" mb={0.5}>
            <strong>Lorem</strong>
          </Typography>
        </TimelineContent>
      </TimelineItem>
      <TimelineItem>
        <TimelineOppositeContent color="text.secondary" className="timelineYear">
          2020
        </TimelineOppositeContent>
        <TimelineSeparator className="timelineSeparator">
          <TimelineDot className="timelineDot" />
          <TimelineConnector className="" />
        </TimelineSeparator>
        <TimelineContent>
          <Typography variant="body2" className="timeLineText">
            Date
          </Typography>
          <Typography variant="body2" className="timeLineHeading" mb={0.5}>
            <strong>11/10/2022</strong>
          </Typography>
          <Typography variant="body2" className="timeLineText">
            User
          </Typography>
          <Typography variant="body2" className="timeLineHeading" mb={0.5}>
            <strong>Ajay</strong>
          </Typography>
          <Typography variant="body2" className="timeLineText">
            Task
          </Typography>
          <Typography variant="body2" className="timeLineHeading" mb={0.5}>
            <strong>Task1</strong>
          </Typography>
          <Typography variant="body2" className="timeLineText">
            Assign to
          </Typography>
          <Typography variant="body2" className="timeLineHeading" mb={0.5}>
            <strong>Vijay</strong>
          </Typography>
          <Typography variant="body2" className="timeLineText">
            Message
          </Typography>
          <Typography variant="body2" className="timeLineHeading" mb={0.5}>
            <strong>Lorem</strong>
          </Typography>
        </TimelineContent>
      </TimelineItem>
      <TimelineItem>
        <TimelineOppositeContent color="text.secondary" className="timelineYear">
          2019
        </TimelineOppositeContent>
        <TimelineSeparator className="timelineSeparator">
          <TimelineDot className="timelineDot" />
          <TimelineConnector className="" />
        </TimelineSeparator>
        <TimelineContent>
          <Typography variant="body2" className="timeLineText">
            Date
          </Typography>
          <Typography variant="body2" className="timeLineHeading" mb={0.5}>
            <strong>11/10/2022</strong>
          </Typography>
          <Typography variant="body2" className="timeLineText">
            User
          </Typography>
          <Typography variant="body2" className="timeLineHeading" mb={0.5}>
            <strong>Ajay</strong>
          </Typography>
          <Typography variant="body2" className="timeLineText">
            Task
          </Typography>
          <Typography variant="body2" className="timeLineHeading" mb={0.5}>
            <strong>Task1</strong>
          </Typography>
          <Typography variant="body2" className="timeLineText">
            Assign to
          </Typography>
          <Typography variant="body2" className="timeLineHeading" mb={0.5}>
            <strong>Vijay</strong>
          </Typography>
          <Typography variant="body2" className="timeLineText">
            Message
          </Typography>
          <Typography variant="body2" className="timeLineHeading" mb={0.5}>
            <strong>Lorem</strong>
          </Typography>
        </TimelineContent>
      </TimelineItem>
      <TimelineItem>
        <TimelineOppositeContent color="text.secondary" className="timelineYear">
          2018
        </TimelineOppositeContent>
        <TimelineSeparator className="timelineSeparator">
          <TimelineDot className="timelineDot" />
          <TimelineConnector className="timelineConnector" />
        </TimelineSeparator>
        <TimelineContent>
          <Typography variant="body2" className="timeLineText">
            Date
          </Typography>
          <Typography variant="body2" className="timeLineHeading" mb={0.5}>
            <strong>11/10/2022</strong>
          </Typography>
          <Typography variant="body2" className="timeLineText">
            User
          </Typography>
          <Typography variant="body2" className="timeLineHeading" mb={0.5}>
            <strong>Ajay</strong>
          </Typography>
          <Typography variant="body2" className="timeLineText">
            Task
          </Typography>
          <Typography variant="body2" className="timeLineHeading" mb={0.5}>
            <strong>Task1</strong>
          </Typography>
          <Typography variant="body2" className="timeLineText">
            Assign to
          </Typography>
          <Typography variant="body2" className="timeLineHeading" mb={0.5}>
            <strong>Vijay</strong>
          </Typography>
          <Typography variant="body2" className="timeLineText">
            Message
          </Typography>
          <Typography variant="body2" className="timeLineHeading" mb={0.5}>
            <strong>Lorem</strong>
          </Typography>
        </TimelineContent>
      </TimelineItem>
    </Timeline>
  );
}
